import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useEventRegistrationsSubscription, usePasswordStrengthMutation, } from "@app/graphql";
import { Col, Row } from "antd";
import debounce from "lodash/debounce";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import { ErrorResult, FourOhFour, LoadingPadded, useBreakpoint } from "./";
export { useTranslation as useTranslation };
export function useQuerySlug() {
    const router = useRouter();
    const { slug: rawSlug } = router.query;
    return String(rawSlug);
}
export function useQueryId() {
    const router = useRouter();
    const { id: rawId } = router.query;
    return String(rawId);
}
export function useLoading(query, dataField, spinnerSize = "huge") {
    const { data, fetching, error, stale } = query;
    let child = null;
    const hasData = !!data?.[dataField];
    if (hasData) {
    }
    else if (!error && !fetching && !stale && hasData) {
    }
    else if (fetching || stale) {
        child = _jsx(LoadingPadded, { size: spinnerSize });
    }
    else if (error && !stale) {
        child = _jsx(ErrorResult, { error: error });
    }
    else {
        child = _jsx(FourOhFour, {});
    }
    return (child && (_jsx(Row, { children: _jsx(Col, { flex: 1, children: child }) })));
}
export function useEventRegistrations(eventId, after = new Date().toISOString(), initialRegistrations = []) {
    const [registrations, setRegistrations] = useState(initialRegistrations);
    useEffect(() => {
        if (initialRegistrations?.[0]) {
            setRegistrations(initialRegistrations);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEventRegistrationsSubscription({
        variables: { eventId, after },
        pause: !eventId,
    }, (_prev, response) => {
        const registrations = response?.eventRegistrations
            ?.registrations;
        setRegistrations(registrations);
        return undefined;
    });
    return registrations;
}
export function useIsMobile() {
    const screens = useBreakpoint();
    const isMobile = screens["xs"];
    return isMobile;
}
export function usePasswordStrength(changedValues, fieldName = "password") {
    const [strength, setStrength] = useState(0);
    const [suggestions, setSuggestions] = useState([]);
    const [_, getPasswordStrength] = usePasswordStrengthMutation();
    const getPasswordStrengthDebounced = useMemo(() => debounce(async (password) => {
        const { data } = await getPasswordStrength({ password });
        const { score, feedback } = data?.calculatePasswordStrength || {};
        setStrength(score || 0);
        setSuggestions(feedback?.suggestions || []);
    }, 500), [getPasswordStrength]);
    useEffect(() => {
        const password = changedValues?.[fieldName];
        if (password) {
            getPasswordStrengthDebounced(password);
        }
    }, [changedValues, fieldName, getPasswordStrengthDebounced]);
    return { strength, suggestions };
}
//# sourceMappingURL=hooks.js.map